import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import ProfilesPageBanner from './ProfilesPageBanner';
import {Link, useNavigate} from 'react-router-dom';
import { useEffect, useState } from 'react';
import Pagination from '../../Components/Pagination';

const VIEW_PROFILES_URL = '/profiles/';

function Profiles({id, img}) {
    const axiosPrivate = useAxiosPrivate();

    const [totalPages, setTotalPages] = useState(0);
    const [profiles, setProfiles] = useState([]);
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    
      useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        axiosPrivate.get(VIEW_PROFILES_URL + id + '?page=' + page).then((response) => {
            if(isMounted){
                setProfiles(response.data.docs);
                setTotalPages(response.data.pages);
            }
        }).catch((error) => {
            //Handle Errors Coming out of this
        });
        return () => { isMounted = false; controller.abort();  }
        // eslint-disable-next-line
    }, [page]);
    
    let team = '';
    let ptag = '';
    if(id === 10){
        team = 'governors';
        ptag = 'Governors'
    }else if(id === 20){
         team = 'management';
        ptag = 'Management'
    }else if(id === 30){
        team = 'teachers';
        ptag = 'Teachers'
    }

    return (
        <>
            <ProfilesPageBanner tag={ptag} team={team} img={img}/>           
            <section className='pt-90 pb-120 gray-bg'>
                <div className="container">
                    <div className="row">
                        { profiles.map((value)=>{
                            return (
                                <div className="col-lg-3 col-sm-6" key={value.id}>
                                    <div className="singel-teachers mt-30 text-center" onClick={() => navigate(`/profiles/view/${value.id}`)} style={{cursor: 'pointer'}}>
                                        <div className="blog-thum overflow-hidden" style={{height:'200px'}}>
                                            <img className="img-fluid w-100 h-100" src={img + value.pictures} alt="Profile" style={{objectFit: 'cover'}} loading='lazy'/>
                                        </div>
                                        <div className="cont">
                                            <Link to={`/profiles/view/${value.id}`}><h6>{value.name}</h6></Link>
                                            <span>{value.position}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>{/* row with profile cards*/}
                    {totalPages>1 &&
                        <div className="col-lg-12">
                            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
                        </div>
                    }        
                </div>
            </section>
        </>
    )
}

export default Profiles